import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import { connectInfiniteHits, connectSearchBox } from 'instantsearch.js/es/connectors';
import { SiteUtilities } from './utils';

const init = () => {
  const $body = $('body');
  const product = $body.data('product-name');
  const $navSecondary = $('.nav-secondary');
  const $navBurger = $('.nav-burger');
  const $siteSearchMobileIcon = $('.site-search-mob i');
  const $navSiteSearch = $('.nav-site-search');
  $navSiteSearch.on('click', function (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    $navSiteSearch.toggleClass('active');
    if ($(this).hasClass('active')) {
      // Hide nav burger
      $navSecondary.hide();
      $navBurger.addClass('hide');
      // Change mobile search icon to close
      $siteSearchMobileIcon.addClass('icon-close').removeClass('icon-site-search');
      $('nav').addClass('nav-sticky');
      const widthBefore = $body.outerWidth();
      // Hide Overflow
      $('html, body').css({
        overflow: 'hidden'
      });
      /*
       * Find a body scrollbar width to avoid jerk while opening the modal
       * Jerk will be only observed when scrollbar is always enable in state
       */
      const bodyDifferenceWidth = $body.outerWidth() - widthBefore;
      // Set the scrollbar width as (padding/margin)-right to body and nav
      $body.css('margin-right', bodyDifferenceWidth + 'px');
      $('nav').css('padding-right', bodyDifferenceWidth + 'px');
      // Open search modal
      $('#modal-search').addClass('active');
      // Focus search input
      $('.site-search-bar input').focus();
    } else {
      // Show nav burger
      $navSecondary.show();
      $navBurger.removeClass('hide');
      // Change mobile search icon to back to search
      $siteSearchMobileIcon.addClass('icon-site-search').removeClass('icon-close');
      $(document).trigger('scroll');
      // Close search modal
      $('#modal-search').removeClass('active');
      // Enable overflow
      $('html, body').css({
        overflow: 'auto'
      });
      // Reset (padding/margin)-right from body and nav while closing the modal
      $body.css('margin-right', '');
      $('nav').css('padding-right', '');
      // Clear the search
      const clearSearchEvent = new Event('clearSearch');
      const searchInput = document.getElementById('al-search-input');
      searchInput.dispatchEvent(clearSearchEvent);
    }
  });
  $navSiteSearch.on('keypress', onKeyPressEvent);
  // Close the modal
  $('#modal-search .icon-close').on('click', function () {
    $('.nav-site-search:not(.site-search-mob)').trigger('click');
  });
  function onKeyPressEvent (event) {
    const code = event.which || event.keyCode || 0;
    if (code === 13) $(this).trigger('click');
  }
  $('#modal-search .icon-close').on('keypress', onKeyPressEvent);
  try {
    const algoliaClient = algoliasearch('0MOOL54XJV', 'b8e6f90a18c9dec3fa25bec4673c1439');
    const searchClient = {
      search (requests) {
        const newRequests = requests.filter((request) => {
          // add request only when we have a valid search string
          if (request.params.query && request.params.query.length > 0) {
            return request;
          }
        });
        return algoliaClient.search(newRequests);
      }
    };
    // Supports only for freshservice now
    const search = instantsearch({
      indexName: 'production_freshservice',
      searchClient
    });
    /*
     * Custom infiniteHits start
     * This results container get shown after the search query is typed
     * Scroll event is binded in this widget for search modal to perform infinite hits
     */
    let lastRenderOptions;
    let isContentLoaded;
    const renderInfiniteHits = (renderOptions, isFirstRender) => {
      // Rendering logic
      const { hits, showMore, widgetParams, results } = renderOptions;
      lastRenderOptions = renderOptions;
      const { container } = widgetParams;
      const noResultsContainer = document.querySelector('#modal-search .no-results');
      if (results && results.query === '') {
        container.style.display = 'none';
      } else {
        container.style.display = '';
      }
      isContentLoaded = true;
      if (isFirstRender) {
        container.appendChild(document.createElement('ul'));
        // Infininte Scroll Starts
        if (!('IntersectionObserver' in window) ||
        !('IntersectionObserverEntry' in window) ||
        !('intersectionRatio' in window.IntersectionObserverEntry.prototype) ||
        !('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
          // this block will helps to run infinite scroll when intersectinobserver is not supported
          $('#modal-search').on('scroll', function () {
            const scrollHeight = $(this).prop('scrollHeight');
            const scrollTop = $(this).scrollTop() + $(this).outerHeight();
            if (scrollTop >= scrollHeight && isContentLoaded && lastRenderOptions.isLastPage === false) {
              isContentLoaded = false;
              const loadingInfo = document.createElement('span');
              loadingInfo.className = 'infinite-loading-txt';
              loadingInfo.innerText = 'Loading...';
              container.appendChild(loadingInfo);
              showMore();
            }
          });
        } else {
          const sentinel = document.createElement('div');
          container.appendChild(sentinel);
          const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting && lastRenderOptions.isLastPage === false) {
                showMore();
                const loadingInfo = document.createElement('span');
                loadingInfo.className = 'infinite-loading-txt';
                loadingInfo.innerText = 'Loading...';
                container.appendChild(loadingInfo);
              }
            });
          });
          observer.observe(sentinel);
        }
        return;
        // Infinite Scroll Ends
      }
      const $infniteLoadingTxt = container.querySelector('.infinite-loading-txt');
      if ($infniteLoadingTxt) {
        $infniteLoadingTxt.remove();
      }
      container.querySelector('ul').innerHTML = hits
        .map(
          hit => {
            let childContent = `
              <div class="hit-name">
                ${hit.title}
              </div>
              <div class="hit-description">
                ${instantsearch.highlight({ attribute: 'description', hit })}
              </div>
            `;
            if (!hit.title && !hit.description) {
              childContent = hit.url;
            }
            return `
            <li>
              <div class="results">
                <a href="${hit.url}?q=${encodeURIComponent(results.query)}">
                  ${childContent}
                </a>
              </div>
            </li>
            `;
          }
        )
        .join('');
      // Showing no results
      if (results.query && !hits.length) {
        noResultsContainer.style.display = 'block';
      } else {
        noResultsContainer.style.display = 'none';
      }
    };
    // This is the connector used to connect infinite hits widget function
    const customInfiniteHits = connectInfiniteHits(
      renderInfiniteHits
    );
    // Custom infiniteHits end
    // Custom searchBox start
    let searchDeboucer;
    /*
     * This is the search box widget
     * Any custom behaviour to the search box can be added to this function like showing correct query etc.
     */
    const renderSearchBox = (renderOptions, isFirstRender) => {
      const { query, refine, widgetParams, clear } = renderOptions;
      if (isFirstRender) {
        const label = document.createElement('label');
        const input = document.createElement('input');
        label.setAttribute('for', 'al-search-input');
        // Create span elem to show search query
        const span = document.createElement('span');
        span.className = 'search-query';
        // Showing results for feature currently not supported
        span.style.display = 'none';
        // Wrapper class
        const wrapper = document.createElement('div');
        wrapper.className = 'site-search-bar';
        // Input behaviours
        input.placeholder = widgetParams.placeholder;
        label.innerText = widgetParams.placeholder;
        input.id = 'al-search-input';
        input.autocomplete = input.autocorrect = input.autocapitalize = 'off';
        $(input).on('keyup keypress paste', function (e) {
          const value = (e.target.value) ? SiteUtilities.escapeHtml(e.target.value) : '';
          refine(value);
        });
        // Clear search
        input.addEventListener('clearSearch', event => {
          clear();
        });
        // End clear search
        widgetParams.container.appendChild(wrapper);
        const $wrapperElem = widgetParams.container.getElementsByClassName('site-search-bar')[0];
        $wrapperElem.appendChild(input);
        $wrapperElem.appendChild(label);
        $wrapperElem.appendChild(span);
      }
      widgetParams.container.querySelector('input').value = query;
      const $searchQuery = widgetParams.container.querySelector('span');
      if (query.length) {
        $searchQuery.innerHTML = `Showing results for <i>${query}</i>`;
      }
    };
    const customSearchBox = connectSearchBox(
      renderSearchBox
    );
    // Custom searchBox end
    search.addWidget(
      customSearchBox({
        container: document.querySelector('#searchbox'),
        placeholder: 'Search www.freshworks.com',
        queryHook (query, refine) {
          clearTimeout(searchDeboucer);
          searchDeboucer = setTimeout(() => refine(query), 500);
        }
      })
    );
    search.addWidget(
      customInfiniteHits({
        container: document.querySelector('#infinite-hits')
      })
    );
    search.start();
  } catch (e) {
    SiteUtilities.log(
      'Error while initializing site search',
      'error',
      'sitesearch.init',
      0,
      e
    );
  }
};

export default init;
